module.exports = __webpack_public_path__ + "static/media/6a2.43c0af97.jpg";